module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_23-988543f6b5a972668a6fba76251237b7.jpg";